import { Box } from '@mui/material';
import { useDispatch } from 'react-redux';

import { ModalContentContainer } from '@/components';
import { ShareWithAFriendForm } from '@/containers/ShareWithAFriendForm';
import { freeTrialShare } from '@/images';
import { uiActions } from '@/store';

export type ShareWithAFriendFormState = {
  firstName: string;
  lastName: string;
  email: string;
  message: string;
};

export const ShareWithAFriendModalContent = () => {
  const dispatch = useDispatch();

  const onClose = () => {
    dispatch(uiActions.closeActiveModal());
  };

  return (
    <Box sx={{ width: { xs: 'auto', md: 800 }, height: 600 }}>
      <ModalContentContainer
        onModalClose={onClose}
        stretch
        leftColumnContents={
          <Box sx={{ mx: 'auto' }}>
            <Box
              component="img"
              src={freeTrialShare}
              sx={{ width: 190, mt: 3 }}
            />
          </Box>
        }>
        <ShareWithAFriendForm onSuccess={onClose} />
      </ModalContentContainer>
    </Box>
  );
};
